/* src/app/shared/components/flow-switch/flow-switch.component.scss */
.switch {
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  width: 70px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background-color: #e4e4e7;
  cursor: pointer;
  outline: none;
  transition: background-color 0.15s ease;
}
.switch:hover {
  background-color: #f4f4f5;
}
.switch.on {
  background-color: #4568d0;
}
.switch.on:hover {
  background-color: #5580dc;
}
.switch.on .thumb {
  transform: translateX(21px);
}
.switch:focus-visible {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(89, 113, 197, 0.5);
}
.switch:disabled {
  cursor: not-allowed;
  background-color: #e4e4e7;
}
.switch:disabled:hover {
  background-color: #e4e4e7;
}
.switch:disabled.on {
  background-color: #c8d9f5;
}
.switch:disabled.on:hover {
  background-color: #c8d9f5;
}
.switch .thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 45px;
  height: 28px;
  border-radius: 999px;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(34, 34, 34, 0.15);
  transition: transform 0.15s ease;
}
/*# sourceMappingURL=flow-switch.component.css.map */
